<template>
  <v-layout row justify-center>
    <v-dialog v-model="showAdminPhotoGrid" max-width="98%"
      transition="dialog-bottom-transition" @keydown.esc="showAdminPhotoGrid = false">
      <v-card>
        <v-card-text>
          <v-layout align-content-start row wrap justify-start>
            <v-flex xs12 md8>
              <div class="photo-wrapper">
                <div class="photo-container">
                  <span class="photo-bg-mask"
                    v-bind:style="{ backgroundSize: 'cover', backgroundImage: `url(${photo.url})` }"></span>
                  <span class="photo-mask"
                    v-bind:style="{
                      backgroundSize: 'cover',
                      backgroundImage: `url(${photo.url})`,
                      left: `${photo.x}px`,
                      top: `${photo.y}px`,
                      transform: `rotate(${photo.deg}deg)`,
                      transformOrigin: '50% 50%'
                    }"></span>
                  <img :src="photo.url" style="max-width: 100%; height: auto; display: block; opacity: 0">
                  <div class="photo-grid">
                    <span class="vertical-line"></span><span class="vertical-line"></span><span class="vertical-line"></span><span class="vertical-line"></span><span class="vertical-line"></span><span class="vertical-line"></span>
                    <span class="vertical-line"></span><span class="vertical-line"></span><span class="vertical-line"></span><span class="vertical-line"></span><span class="vertical-line"></span>

                    <span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span>
                    <span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span>
                    <span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span>
                    <span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span><span class="horizontal-line"></span>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md4 style="padding-left: 30px;">
              <v-layout row wrap>
                <v-flex xs9>
                  <v-slider prepend-icon="fal fa-arrows-h" v-model="photo.x" :max="max" :min="min"></v-slider>
                </v-flex>
                <v-flex xs3>
                  <v-text-field v-model="photo.x" class="mt-0" hide-details
                    single-line type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex xs9>
                  <v-slider prepend-icon="fal fa-arrows-v" v-model="photo.y" :max="max" :min="min"></v-slider>
                </v-flex>
                <v-flex xs3>
                  <v-text-field v-model="photo.y" class="mt-0" hide-details
                    single-line type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field prepend-icon="fal fa-sync" v-model="photo.deg" class="mt-0" hide-details
                    single-line type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <br><br>
                  <v-btn round large depressed
                     @click.stop="showAdminPhotoGrid = false">
                    Cancelar
                  </v-btn>
                  <v-btn @click.stop="save()" round large depressed color="success"
                    :loading="loadingRequest">
                    Salvar alterações
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'

export default {
  data: () => ({
    showAdminPhotoGrid: false,
    loadingRequest: false,
    min: -200,
    max: 200,
    photo: {}
  }),

  methods: {
    save () {
      this.loadingRequest = true
      // eslint-disable-next-line
      axios.put(`${API.userEvaluationsPhotos}/${this.photo._id}`, this.photo).then(response => {
        this.loadingRequest = false
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro apagar ao salvar a foto', color: 'error' })
        this.loadingRequest = false
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('showAdminPhotoGrid')
    EventBus.$off('showAdminPhotoGridData')
  },

  mounted () {
    EventBus.$on('showAdminPhotoGrid', data => {
      this.showAdminPhotoGrid = data
    })

    EventBus.$on('showAdminPhotoGridData', data => {
      if (!data.x) { data.x = -100 }
      if (!data.y) { data.y = -100 }
      if (!data.deg) { data.deg = 0 }

      this.photo = data
    })
  },

  props: ['user']
}
</script>

<style scoped>
.photo-container {
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.photo-bg-mask,
.photo-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.photo-bg-mask {
  z-index: 1;
  filter: blur(50px);
  -webkit-filter: blur(50px);
  width: calc(100% + 200px);
  height: calc(100% + 200px);
  top: -100px;
  left: -100px;
}
.photo-mask { z-index: 2 }
.photo-grid { z-index: 3 }

.photo-grid {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  /* border: 2px solid #fff; */
  border-right: 0;
  border-bottom: 0;
}

.vertical-line {
  width: 9.09%;
  border-right: 2px solid rgba(255, 255, 255, 0.6);
  float: left;
  display: block;
  height: 100%;
}

.horizontal-line {
  width: 100%;
  border-bottom: 2px solid  rgba(255, 255, 255, 0.6);
  display: block;
  height: 3.95%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/evaluations/AdminPhotoGrid.vue